import { ReactElement, ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ChevronLeftIcon } from '@navikt/aksel-icons';
import { Heading } from '../Heading/Heading';
import { Paragraph } from '../Paragraph/Paragraph';
import classes from './FocusPageLayout.module.css';

type FocusPageLayoutProps = {
  title: string;
  subtitle?: string;
  children: ReactNode;
  bottomContent?: ReactNode;
  backLink: string;
  backLinkLabel?: string;
};

export const FocusPageLayout = ({
  title,
  subtitle,
  children,
  bottomContent,
  backLink,
  backLinkLabel,
}: FocusPageLayoutProps): ReactElement => {
  const { t } = useTranslation();
  const finalBackLinkLabel = backLinkLabel ?? t('common.back');

  return (
    <div className={classes.container}>
      <div className={classes.contentContainer}>
        <Link
          to={backLink}
          className={classes.backLink}
          aria-label={finalBackLinkLabel}
        >
          <ChevronLeftIcon aria-hidden="true" fontSize={'20px'} />
          <span>{t('common.back')}</span>
        </Link>

        <div className={classes.content}>
          <div className={classes.header}>
            <Heading as="h1" className={classes.title}>{title}</Heading>
            {subtitle && <Paragraph className={classes.subtitle}>{subtitle}</Paragraph>}
          </div>

          {children}
        </div>

        {bottomContent}
      </div>
    </div>
  );
};
